import { Injectable, inject } from '@angular/core';
import { Observable, catchError, finalize, map, of, shareReplay, tap } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { ProfileService } from '../profile/profile.service';
import { LanguageService } from './language.service';

@Injectable({ providedIn: 'root' })
export class LanguageBootstrapService {
  private readonly authService = inject(AuthService);
  private readonly profileService = inject(ProfileService);
  private readonly languageService = inject(LanguageService);
  private inFlight$: Observable<void> | null = null;

  ensureLoaded(): Observable<void> {
    if (!this.authService.isAuthenticated()) {
      return of(void 0);
    }

    if (this.inFlight$) {
      return this.inFlight$;
    }

    this.inFlight$ = this.profileService.getProfile().pipe(
      tap((profile) => {
        if (profile.languageCode) {
          this.languageService.setLanguage(profile.languageCode);
        }
      }),
      map(() => void 0),
      catchError(() => of(void 0)),
      finalize(() => {
        this.inFlight$ = null;
      }),
      shareReplay(1)
    );

    return this.inFlight$;
  }
}

